import * as BsIcons from "react-icons/bs";
import {forwardRef, useImperativeHandle, useRef, useState} from "react";
import {useTranslation} from "react-i18next";

export interface TerminalStatusBarProps {
    status_color?: string;

    instance_status?: string;
    console_status?: string;

    instance_name?: string;
    os_image: string;
    instance_ip_list?: string[];
}

export type TerminalStatusBarRef = HTMLDivElement;

const TerminalStatusBar = forwardRef<TerminalStatusBarRef, TerminalStatusBarProps>(
    (props: TerminalStatusBarProps, ref) => {
        const {t} = useTranslation();

        const divRef = useRef<HTMLDivElement>(null);
        const [isVisibleDetail, setVisibleDetail] = useState(false);

        useImperativeHandle(ref, () => divRef.current!);

        function toggleContent() {
            setVisibleDetail(!isVisibleDetail);
        }

        return (
            <div ref={divRef} className="card rounded-4 p-4 my-3 border-0">
                <h4 className="text-center mb-0" style={{color: props.status_color}}>
                    {t("terminal.serverStatus")}
                    &nbsp;- <span id="instance_status">{props.instance_status}</span>
                    &nbsp;- <span id="console_status">{props.console_status}</span>
                    <span style={{float: "right"}}>
                    <button type="button" className="button_blue rounded-2 pt-0 pb-1 mb-0" onClick={toggleContent}>
                        <i className="px-1 " style={{fontSize: "22px", fontWeight: "bold"}}>
                        <BsIcons.BsPlusLg/></i>
                    </button>
                </span>
                </h4>

                <div style={{display: isVisibleDetail ? 'block' : 'none'}}>
                    <hr/>

                    <div className="row text-center text-secondary">
                        <div className="col-md-4">
                            <div className="form-group">
                                <h5>{t("instance.instanceName")}</h5>
                                <span className="fs-5" id="instance_name">{props.instance_name}</span>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <h5>{t("instance.imageName")}</h5>
                                <span className="fs-5" id="os_image">{props.os_image}</span>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <h5>{t("terminal.instanceIp")}</h5>
                                <span className="fs-5" id="instance_ip">
                                    <span>{props.instance_ip_list?.join(",")}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
)

export default TerminalStatusBar;

